import { SourceLabel } from "@/components/workspace/source-icon";

export function WorkflowLabel({ source, name }: { source: string; name: string }) {
  // The connector logo replaces the catalog name's connector prefix.
  return <SourceLabel source={source} label={name.split(" · ").pop() || name} />;
}
